import React from 'react';
export const DropDownCustom = ({ data, handleChange, defaultValue, id }) => {

    return <div className="DropDown-Shift">
        <select id={id} onChange={handleChange} value={defaultValue}>
            <option value={defaultValue} hidden disabled>{defaultValue}</option>
            {data.map(shiftName => {
                return <option key={shiftName.shiftId} value={JSON.stringify(shiftName)}>
                    {shiftName.shiftStartTime + " - " + shiftName.shiftEndTime + " - " + shiftName.shiftPlan}
                </option>
            })}
        </select>
    </div>

}